import { useEffect, useState } from "react";
import { selectCustomersListLoadingPag, selectCustomersListPag } from "../../redux/customers/selectors";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { createCustomer, deleteCustomer, editCustomer, getCustomersPag } from "../../redux/customers/thunks";
import { openModal } from "../../redux/modal/modalSlice";
import { useTranslation } from "react-i18next";
import { validateEmail } from "../../commonFunctions/commonFunctions";



const initialSortOptions = {
    columna: "customerId",
    sortOrderAsc: true
}

function CustomerManagement() {
    const { t } = useTranslation();
    const customers = useSelector(selectCustomersListPag);
    const dispatch = useDispatch();
    const loading = useSelector(selectCustomersListLoadingPag);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    

    useEffect(()=>{
        getListCustomers(mapPageInfo(customers));
    }, [])

    function mapPageInfo(customersData){
        return {
            pageIndex: customersData.pageIndex ?? 0,
            pageSize: customersData.pageSize ?? 10,
            orderByField:  customersData.columna ?? "customerId",
            orderByAscending:  customersData.sortOrderAsc ?? true
        }
    }
      
    const getListCustomers = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getCustomersPag({query}));
    }

    const columnsCustomers = [
        <Column sortIndex={1} key={"customer-1"} dataField="customerId" caption="Código" allowEditing={false} allowCreating={false}/>, 
        <Column key={"customer-2"} dataType={"cpf"} dataField="cpf" caption="CPF" allowEditing={true} allowCreating={true}/>, 
        // <Column key={"customer-2"} dataType={"cpf"} dataField="cpf"
        //     customizeText={(cellInfo) => formatCPF(cellInfo.value)}
        //     //cellRender={({value})=>formatCPF([value])}
        //     caption="CPF" allowEditing={true} allowCreating={true}/>, 
        <Column key={"customer-3"} dataType={"string"} dataField="customerName" caption={t("Name")} allowEditing={true} allowCreating={true}/>, 
        <Column key={"customer-4"} dataType={"string"} dataField="phone" caption={t("Phone")} allowEditing={true} allowCreating={true}/>, 
        <Column key={"customer-5"} dataType={"email"} dataField="email" caption="E-mail" allowEditing={true} allowCreating={true}/>,
        <Column key={"customer-6"} dataType={"string"} dataField="address" caption={t("Address.Name")} allowEditing={true} allowCreating={true}/>,
        <Column key={"customer-7"} dataType={"string"} dataField="zipCode" caption={t("Address.ZipCode")} allowEditing={true} allowCreating={true}/>,
        <Column key={"customer-8"} dataType={"string"} dataField="city" caption={t("Address.City")} allowEditing={true} allowCreating={true}/>,
        <Column key={"customer-9"} dataType={"string"} dataField="neighborhood" caption={t("Address.Neighborhood")} allowEditing={true} allowCreating={true}/>,
        <Column key={"customer-10"} dataType={"string"} dataField="state" caption={t("Address.State")} allowEditing={true} allowCreating={true}/>
    ] 

    const formatCPF = (cellValue) => {
        if (!cellValue) return "";
        
        // Remove non-numeric characters to ensure proper formatting
        const numericValue = cellValue.toString().replace(/\D/g, '');
        
        // Apply mask
        return numericValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    };

    // function formatCPF(cellValue){
    //     console.log("formatCPF", cellValue)
    //     if (!cellValue) return "";
  
    //     // Remove non-numeric characters to ensure proper formatting
    //     const numericValue = cellValue.toString().replace(/\D/g, '');
        
    //     // Apply mask
    //     return numericValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    // }

    function handleSaveNewCustomerClick(value, closeCreateModal) {

        // Validação de Campos
        if (!value.customerName || value.customerName.trim() === '') {
            dispatch(openModal({ type: 'warning', message: `O campo Nome é obrigatório` }));
            return false;
        }
        if (!value.phone || value.phone <= 0) {
            dispatch(openModal({ type: 'warning', message: `O campo Telefone é obrigatório` }));
            return false;
        }
        if (value.email) {
            if(!validateEmail(value.email)){
                dispatch(openModal({ type: 'warning', message: `Formato de e-mail inválido` }));
                return false;
            }
        }

        
        
        // const customerCPF = value.cpf.trim();
        // if(customerCPF){
        //     // const customerDescriptionExists = customers.elements.some(customer => customer.cpf.toLowerCase() === customerCPF.toLowerCase());
        //     // if(customerDescriptionExists)
        //     //     dispatch(openModal({ type: "warning", message:"La Descrição introducida ya existe."}))
        //     // else{
         const customerParams ={body:
            {
                cpf: value?.cpf?.trim(),
                customerName: value.customerName?.trim(),
                phone: value?.phone?.trim(),
                email: value?.email?.trim(),
                address: value?.address?.trim(),
                zipCode: value?.zipCode?.trim(),
                city: value?.city?.trim(),
                neighborhood: value?.neighborhood?.trim(),
                state: value?.state?.trim(),
            }
        }
        dispatch(createCustomer(customerParams)).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                getListCustomers(mapPageInfo({...customers, ...sortOptions}));
                closeCreateModal();
            }                    
        })       
        //     // }            
        // }else{
        //    closeCreateModal()
        // }       
    }    

    const handleEditClick = (value, closeEditModal) => {

        if (!value.customerName || value.customerName.trim() === '') {
            dispatch(openModal({ type: 'warning', message: `O campo Nome é obrigatório` }));
            return false;
        }
        if (!value.phone || value.phone <= 0) {
            dispatch(openModal({ type: 'warning', message: `O campo Telefone é obrigatório` }));
            return false;
        }

        if (value.email) {
            if(!validateEmail(value.email)){
                dispatch(openModal({ type: 'warning', message: `Formato de e-mail inválido` }));
                return false;
            }
        }

        // const customerCPF = value.cpf.trim();
        // if(customerCPF){
        //     // const cpfExists = customers.elements.some(customer => customer.cpf.toLowerCase() === customerCPF.toLowerCase());            
        //     // if(cpfExists && customerCPF.toLowerCase() !== customers.elements.find(customer => customer.customerId === value.customerId)?.cpf.toLowerCase()) //La descripción ya existe y es distinta a la actual
        //     //     dispatch(openModal({ type: "warning", message:"La Descrição introducida ya existe."}))
        //     // else{
        const editCustomerParams ={
            param: value.customerId,
            customerId: value.customerId,
            body:{
                cpf: value?.cpf?.trim(),
                customerName: value?.customerName.trim(),
                phone: value?.phone?.trim(),
                email: value?.email?.trim(),
                address: value?.address?.trim(),
                zipCode: value?.zipCode?.trim(),
                city: value?.city?.trim(),
                neighborhood: value?.neighborhood?.trim(),
                state: value?.state?.trim(),
            }
        }
        dispatch(editCustomer(editCustomerParams)).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                getListCustomers(mapPageInfo({...customers, ...sortOptions}));
                closeEditModal()
            }    
        })
        //     // }
        // }else{
        //    closeEditModal()
        // }             
    }

    const handleDeleteClick = (id, closeDeleteModal) => {
        dispatch(deleteCustomer({param: id})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = customers.pageIndex;

                if (customers.elements.length === 1) {
                    updatedPageIndex = Math.max(0, customers.pageIndex - 1);
                }

                const updatedCustomers = {
                    ...customers,
                    pageIndex: updatedPageIndex,
                };

                getListCustomers(mapPageInfo({...updatedCustomers, ...sortOptions}));
                closeDeleteModal()           
            }
        })  
    }

    function allowDelete(rowData){
        return rowData.data.custom;
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable
                sectionTitle={t("Customers")} 
                masterTitle={t("Customer")} 
                itemIdField={"customerId"} 
                itemDescriptionField={"description"}
                loading={loading} 
                getData={getListCustomers} 
                dataSource={customers} 
                columnasTabla={columnsCustomers} 
                onCreate={handleSaveNewCustomerClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                numElements={[10, 20, 30]}
                allowDelete={allowDelete}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </div>
    )
}
export default CustomerManagement;